export default {
  meta: {
    title: '客户详情',
    url: '/abside/customerdetails',
    urlName: 'ab侧-客户详情',
    logincallback: '/abside',
  }
};
